import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  RecipientValidationMultiRequest,
  RecipientValidationMultiResponse,
  RecipientValidationRequest,
  RecipientValidationResponse,
} from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecipientValidationService {
  constructor(private http: HttpClient) {}

  validate(request: RecipientValidationRequest): Observable<RecipientValidationResponse> {
    return this.http.post<RecipientValidationResponse>('secure/recipient-validation', request);
  }

  validateMulti(
    requests: RecipientValidationMultiRequest,
  ): Observable<RecipientValidationMultiResponse> {
    return this.http.post<RecipientValidationMultiResponse>(
      'secure/recipient-validation/multi',
      requests,
    );
  }
}
